import React from 'react';
import PropTypes from 'prop-types';

import ContentGroupComposition from '../../components/compositions/content/ContentGroup';
import GlobalSection from '../../components/basics/global/GlobalSection';

function ContentGroup({ moduleId, params, layoutSettings, primaryModule, behaviorSettings }) {
  return (
    <GlobalSection
      layout="expanded"
      adjacent={params.adjacent}
      image={params.backgroundImage}
      theme={params.colorScheme}
      layoutSettings={layoutSettings}
    >
      <ContentGroupComposition
        primaryModule={primaryModule}
        align={params.align}
        columns={params.columns}
        theme={params.colorScheme}
        direction={params.direction}
        items={params.groups}
        imageAlign="center"
        moduleId={moduleId}
        withBackgroundImage={!!params.backgroundImage}
        adjacent
        behaviorSettings={behaviorSettings}
      />
    </GlobalSection>
  );
}

ContentGroup.propTypes = {
  params: PropTypes.object.isRequired,
  layoutSettings: PropTypes.object,
  primaryModule: PropTypes.bool.isRequired,
  moduleId: PropTypes.string,
  behaviorSettings: PropTypes.object,
};

export default ContentGroup;
